import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import {fetchList, recipients, combineGenerateOrder} from '@/api/pcm/purchase';
import {Message} from 'element-ui';

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		multipleSelection: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'pcm.purchase.list', async function () {
				const {searchForm} = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...searchForm,
						...payload
					}
				});
			})
		},
		async generateOrder({state, dispatch}, multipleSelection) {
			if (multipleSelection.length <= 0) {
				return Message.error('至少勾选一个采购需求');
			}
			await wait(dispatch, 'pcm.purchase.generate', async function () {
				await recipients({
					purDemandRecIds: multipleSelection.map((v) => {
						return v.recId;
					})
				});
				Message.success('操作成功');
			})
			dispatch('getList')
		},
		async combineGenerateOrder({state, dispatch}, {multipleSelection, depotId}) {
			if (multipleSelection.length <= 0) {
				return Message.error('至少勾选一个采购需求');
			}
			await wait(dispatch, 'pcm.purchase.combineGenerateOrder', async function () {
				await combineGenerateOrder({
					purDemandRecIds: multipleSelection.map((v) => {
						return v.recId;
					}),
					depotId: depotId
				});
				Message.success('操作成功');
			})
			dispatch('getList')
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/purchase/list.js